import styled, { css } from 'styled-components';
import isOmpPlatform from '../../utils/isOmpPlatform';

const isOmp = isOmpPlatform();

const fullsizeVariant = css`
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  text-transform: ${isOmp ? 'none' : 'uppercase'};
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  & svg {
    width: 29px;
    height: 24px;
    margin-right: 7px;

    path {
      fill: ${({ theme }) => theme.COLORS.BASE_INVERTED};
    }
  }
`;

export const watchlistVariants = {
  fullsize: fullsizeVariant,
  fullsize_reverse: css`
    ${fullsizeVariant}

    flex-direction: row-reverse;

    & svg {
      margin-right: 0;
      margin-left: 7px;
    }
  `,
  filled: css`
    path {
      fill: ${({ theme }) => theme.COLORS.TERTIARY};
    }
  `
};

export const StyledWatchListButton = styled.button`
  color: ${({ theme }) => theme.COLORS.BASE};
  background: ${({ theme }) => theme.COLORS.TRANSPARENT};
  cursor: pointer;
  padding: 0.5px;
  border: none;
  outline: none;
  border-radius: none;
  ${props => props.variant && watchlistVariants[props.variant]}

  svg {
    width: 20px;
    height: 18px;
    ${props => props.isWatchlisted && watchlistVariants.filled}
  }
`;
